import { useIntl } from 'react-intl';
import _orderBy from 'lodash/orderBy';

import { Dropdown } from 'components/Forms';

interface IAssignUsersProps {
  handleChange: any;
  options: ISelectOption[];
  value: ISelectOption[];
}

const AssignUsers = ({ handleChange, options, value }: IAssignUsersProps) => {
  const intl = useIntl();

  return (
    <Dropdown
      dataTestId="filter-assignUsers"
      variant="form"
      options={_orderBy(options, [(option) => option.label.toLowerCase(), 'name'], 'asc')}
      placeholder={intl.formatMessage({ id: 'selectUserKey' })}
      onChange={handleChange}
      isMulti
      value={value}
      isClearable={false}
      isSearchable
      useAvatarNameColor
      minWidth={200}
      label={intl.formatMessage({ id: 'assignedTo' })}
      iconRoundedCircle
    />
  );
};

export default AssignUsers;
